module.exports = __webpack_public_path__ + "assets/images/8271a5fe66042078261a4f774d5a0e4c.png";